// extracted by mini-css-extract-plugin
export default {"marketingPage":"Marketing_marketingPage__SVND1","blueP":"Marketing_blueP__bXL0f","email":"Marketing_email__LYvqq"};